import { type ReactElement } from 'react';
import { cn } from '@avanta/shared/utils/cn';

export const Skeleton = ({ className, ...props }: React.ComponentProps<'div'>): ReactElement => (
  <div
    data-slot="skeleton"
    className={cn('bg-gray-200 animate-pulse rounded-md', className)}
    {...props}
  />
);
